module.exports = __webpack_public_path__ + "img/banner-TV-4__lg.1504707c.jpg";